<template>
    <div class="rhythmClass">
        <el-col :span="24" class="zhiAudio" align="left" v-if="heart.questionDto.detailInfo.audioUrl">
            <audio-style 
                style="width:180px;float:left;"
                ref="audioRef"
                @startPlaying="startPlaying"
                @endPlaying="endPlaying"
                @getPlays="getPlays"
                :styleText="'请点击播放'"
                :audioUrl="heart.questionDto.detailInfo.audioUrl"
                class="audioCom"
            ></audio-style>
            <div class="playNum" v-if="false">
                <div class="playNumIng"><img src="./../../../static/images/play.png" alt="" srcset=""></div>
                {{`X${plays}`}}
            </div>
        </el-col>
        <el-col :span="24" class="explainText" v-if="heart.questionDto.detailInfo.audioUrl">
            点击音频部分播放打谱
        </el-col>
        <el-col :span="24" class="imgStyle" align="left">
            <div class="quImg">
                <img :src="heart.questionDto.detailInfo.questionImgUrl" alt="" srcset="">
            </div>
            <div class="playTheDrums">
                <div class="operationBox" style="left:12%;right:12%">
                    <audio-style
                        style="width:70%;float:left;margin-left:15%"
                        ref="audioRecording"
                        v-if="luYingUrl"
                        @startPlaying="startPlayingLuYing"
                        @endPlaying="endPlayingLuYing"
                        @getPlays="getPlaysLuYing"
                        :audioUrl="luYingUrl"
                        class="audioCom"
                    ></audio-style>
                </div>
                <p>请点击播放录制的音频</p>
            </div>
        </el-col>

        <audio ref="tock" :src="tockUrl" v-show="false"></audio>
    </div>
</template>
<script>
import audioStyle from '../../components/audioStyle'
import utils from '../../lib/util'
    export default {
        name:"rhythmChoice",
        props: {
            sonData: Object,
        },
        data() {
            return {
                heart:{
                    questionDto:{
                        detailInfo:{}
                    }
                },
                tockUrl:require('../../../static/music/tock.wav'),
                rhythmBeatVal:[],
                letTime:0,
                timeHer:'',
                plays:0,
                luYingUrl:'',
                setTime:'',
            }
        },
        components:{
            audioStyle
        },
        watch: {},
        beforeDestroy() {},
        computed:{},
        created(){},
        mounted(){
            this.heart = this.sonData
            this.plays = utils.mottoClone(this.heart.questionDto.detailInfo.playTime)
            this.$nextTick(function(){
                let beiArr = utils.mottoClone(this.heart.errorObj.rhythmBeatVal)
                this.$set(this,'rhythmBeatVal',beiArr? beiArr.split(',').map(Number):[])
                this.luYingUrl = this.heart.questionDto.detailInfo.audioUrl
            })
        },
        methods:{
            // 开始答题
            startingExam(){
                if(this.$refs.audioRef.judgePaying()){
                    // 开始答题
                    this.luYingUrl = ''
                    this.getPlays()
                }else{
                    // 停止答题
                    this.$refs.audioRef.endAudio();
                    this.endPlaying()
                }
            },
            clickRhythm(){
                if(this.$refs.audioRef.judgePaying()){
                    this.$message({showClose: true,message: '当前曲子未播放'});
                    return
                }else{
                    this.$refs.tock.currentTime = 0
                    this.$refs.tock.play()
                    
                    this.rhythmBeatVal.push(this.letTime)
                }
            },
            getPlays(){
                if(!this.$refs.audioRecording.judgePaying()){
                    this.$refs.audioRecording.endAudio();
                    clearInterval(this.setTime);
                }
                if(!this.$refs.audioRef.judgePaying()){
                    this.$refs.audioRef.endAudio();
                }
                this.$refs.audioRef.fatherPlay(1000)
            },
            startPlaying(){},
            endPlaying(){},
            endAudio(){
                if(!this.$refs.audioRef.judgePaying()){
                    this.$refs.audioRef.endAudio()
                }
                if(!this.$refs.audioRecording.judgePaying()){
                    this.$refs.audioRecording.endAudio();
                    clearInterval(this.setTime);
                }
            },
            getPlaysLuYing(){
                if(!this.$refs.audioRef.judgePaying()){
                    this.$refs.audioRef.endAudio();
                }
                if(!this.$refs.audioRecording.judgePaying()){
                    this.$refs.audioRecording.endAudio();
                    clearInterval(this.setTime);
                }
                this.$refs.audioRecording.fatherPlay(1000,-1);
                this.testMusic()
            },
            startPlayingLuYing(){},
            endPlayingLuYing(){},
            testMusic(){
                let that = this;
                let num = 0;
                that.setTime = setInterval(()=>{
                    if(that.findCloseNum(that.rhythmBeatVal,num)>=num-5&&that.findCloseNum(that.rhythmBeatVal,num)<num+5){
                        that.$refs.tock.currentTime = 0
                        that.$refs.tock.play();
                    }
                    if(num > Math.max.apply(null, that.rhythmBeatVal)){
                        clearInterval(that.setTime);
                        
                        // that.fleg = false
                        that.playArr = []
                    }
                    num += 10;
                },10)
            },
            findCloseNum(arr, num) {
                var index = 0; 
                var d_value = Number.MAX_VALUE;
                for (var i = 0; i < arr.length; i++) {
                    var new_d_value = Math.abs(arr[i] - num);
                    if (new_d_value <= d_value) {
                        if (new_d_value === d_value && arr[i] < arr[index]) {
                            continue;
                        }
                        index = i;
                        d_value = new_d_value;
                    }
                }
                return Number(arr[index])
            }
        }
    }
</script>
<style scoped lang="less">
    .rhythmClass{
        height: 100%;
        width: 100%;
        .zhiAudio{
            height: 33px;
            width: 100%;
            box-sizing: border-box;
            padding-left: 16px;
            .playNum{
                float: left;
                display: inline-block;
                height: 33px;
                width: 100px;
                .playNumIng{
                    display: inline-block;
                    img{
                        margin: 5px 0 0 15px;
                        vertical-align: text-bottom;
                    }
                }
            }
            .startingToWork{
                float: left;
                margin-right: 20px;
            }
        }
        .explainText{
            box-sizing: border-box;
            padding:5px 0 0 16px;
            text-align: left;
            font-size: 12px;
            color: #A0A1A0;
        }
        .imgStyle{
            width: 100%;
            height: 92%;
            box-sizing: border-box;
            padding: 25px 18px;
            background-image: url('../../../static/images/back-bg.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            .quImg{
                width: 70%;
                height: 100%;
                float: left;
                display: inline-block;
                overflow: hidden;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                    display: table-cell;
                    vertical-align: middle;
                    align-items: center;
                    max-height: 100%;
                    max-width: 100%;
                }
            }
            .playTheDrums{
                width: 30%;
                height: 100%;
                float: right;
                position: relative;
                .operationBox{
                    position: absolute;
                    left: 28%;
                    right: 25%;
                    top: 52%;
                    height: 10%;
                    max-height: 45px;
                    min-height: 35px;
                }
                .playTheDrumsImg{
                    position: absolute;
                    left: 25%;
                    right: 25%;
                    top: 35%;
                    height: 30%;
                    min-height: 95px;
                    background-image: url(data:image/png;base64,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);
                    background-size: 64%;
                    background-position: 50% 50%;
                    background-repeat: no-repeat;
                    cursor: pointer;
                }
                .playTheDrumsImg:active{
                    background-image: url('../../../static/images/drum-down.png'); 
                }
                p{
                    position: absolute;
                    top: 63%;
                    height:15px;
                    left: 0;
                    right: 0;
                    text-align: center;
                    font-size: 12px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/examRecords/rhythmDpChoice.vue